import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { useSelector } from 'react-redux';
import { Image } from 'mangools-react-components/src';

import { currentColorSchemeSelector } from 'selectors/uiSelectors';

import MessageHolder from 'components/messages/MessageHolder';
import Strings from 'constants/Strings';
import sadImg from 'images/sad.svg';
import sadImgDark from 'images/sad-dark.svg';

function FailureMessage(props) {
    const colorScheme = useSelector(state => currentColorSchemeSelector(state));

    if (props.visible) {
        return (
            <MessageHolder onClose={props.onClose}>
                <div className="mg-modal-header is-error">
                    <Image lightSrc={sadImg} darkSrc={sadImgDark} colorScheme={colorScheme} alt="Oh no" width="100" />
                </div>
                <div className="mg-modal-content">
                    <h3 className="font-30 uk-text-bold">{props.header}</h3>
                    {props.details ? <p className="ln-12">{props.details}</p> : null}
                    <p>{props.footer ?? Strings.messages.failure.footer_sorry}</p>
                    {props.link ? (
                        <p>
                            <a
                                className="mg-btn is-green"
                                href={props.link.href}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <strong>{props.link.label}</strong>
                            </a>
                        </p>
                    ) : null}
                </div>
            </MessageHolder>
        );
    } else {
        return null;
    }
}

FailureMessage.propTypes = {
    details: string,
    footer: string,
    header: string,
    link: shape({
        href: string.isRequired,
        label: string.isRequired,
    }),
    onClose: func.isRequired,
    visible: bool.isRequired,
};

FailureMessage.defaultProps = {
    details: null,
    header: 'Sorry, something went wrong',
    link: null,
};

export default FailureMessage;
